<!-- <app-add-preferences></app-add-preferences> -->
<span *ngIf="preferences">
    <app-edit-preferences></app-edit-preferences>
</span>

<span *ngIf="!preferences">
    <app-add-preferences></app-add-preferences>
</span>